'use client'

import type { ForwardedRef, InputHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { cn } from '../lib/utils.ts'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef(function Input(
  { className, type = 'text', ...props }: InputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'ring-offset-background flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
        className,
      )}
      {...props}
    />
  )
})

Input.displayName = 'Input'
